import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
    return (
        <section className="hero">
            <div className="container">
                <div className="hero-content">
                    <h1>K9HKR Studios</h1>
                    <p className="hero-subtitle">Innovative Web Development Solutions</p>
                    <p className="hero-description">
                        Professional full-stack development services specializing in modern web applications,
                        APIs, and digital solutions. Building tomorrow's technology today.
                    </p>
                    <div className="hero-buttons">
                        <a href="#projects" className="btn btn-primary">View Our Work</a>
                        <a href="#contact" className="btn btn-secondary">Get In Touch</a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
